import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import WhatsAppPopup from '../whatsAppPopup/whatsAppPopup'

import {
  FixedContainer,
  WhatsAppWrap,
  FloatingComponentsArea,
  PageTopButtonContainer,
  CookiesWarning,
} from './styles'

import { apiV2 } from 'src/services/api'
import Cookies from 'js-cookie'
import { getCookieDomain } from '../../util/cookie-domain'
import { GCookieToast, GPageTopButton } from '@gazin/ecommerce-ui'

import { voltarAoTopo } from 'src/util/funcoes'

const COOKIE_STORAGE_NAME = '@marketplace-gazin-accepted-cookies'
const PAGINA_SLUG = 'privacidade'

export default function BottomFixed({
  whatsAppPopup = false,
  pageTopButton = false,
  colorTopButton = '',
}) {
  const router = useRouter()
  const [showCookies, setShowCookies] = useState(false)
  const [showPageTopButton, setShowPageTopButton] = useState(false)
  const [loading, setLoading] = useState(false)
  const [buyButtonVisible, setBuyButtonVisible] = useState(false)

  const handleOnScroll = useCallback(() => {
    setShowPageTopButton(window.scrollY > 0)

    if (window?.innerWidth > 991) {
      return setBuyButtonVisible(false)
    }

    if (document.getElementsByClassName('bottom-bar-visible').length) {
      return setBuyButtonVisible(true)
    }

    setBuyButtonVisible(false)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleOnScroll)

    return () => {
      window.removeEventListener('scroll', handleOnScroll)
    }
  })

  useEffect(() => {
    validarCookies()
  }, [])

  const prepareDateToCompare = (date) => {
    const dateFormated = date ? new Date(date) : new Date()
    return dateFormated.setHours(0, 0, 0, 0)
  }

  const validarCookies = () => {
    const cookie = Cookies.get(COOKIE_STORAGE_NAME),
      cookieData = cookie ? JSON.parse(cookie) : false

    if (!cookieData) {
      toggleCookies(false, null)
      setShowCookies(true)
      return
    }

    if (
      cookieData.accepted &&
      prepareDateToCompare(cookieData.last_validation_date) ===
        prepareDateToCompare()
    ) {
      return
    }

    setLoading(true)
    apiV2
      .get(`/canais/pagina/${PAGINA_SLUG}`)
      .then((response) => {
        const acceptOutdated =
          cookieData.accept_date <
          new Date(response.data.data_publicacao).valueOf()

        if (acceptOutdated) {
          toggleCookies(false, cookieData.accept_date ?? null)
          setShowCookies(true)
          return
        }

        toggleCookies(cookieData.accepted, cookieData.accept_date)
        setShowCookies(false)
      })
      .catch(() => {
        setShowCookies(true)
      })
      .finally(() => setLoading(false))
  }

  const toggleCookies = (aceiteCookies, dataAceite) => {
    try {
      Cookies.set(
        COOKIE_STORAGE_NAME,
        JSON.stringify({
          accepted: aceiteCookies,
          accept_date: dataAceite,
          last_validation_date: new Date().valueOf(),
        }),
        {
          domain: getCookieDomain(),
          expires: 400,
        }
      )
      setShowCookies(!showCookies)
    } catch (error) {
      return router.push('/cookie')
    }
  }

  const handlePageTopButtonClick = () => {
    voltarAoTopo()
    setShowPageTopButton(false)
  }

  return (
    <FixedContainer buyButtonVisible={buyButtonVisible}>
      <CookiesWarning active={!loading ? showCookies : false}>
        <GCookieToast
          position="relative"
          cookieText="Coletamos dados para melhorar o desempenho e segurança do site, além de personalizar conteúdos. Verifique mais informações em nossa"
          policyLink={`/pagina/${PAGINA_SLUG}`}
          handleConfirmAndClose={() =>
            toggleCookies(showCookies, new Date().valueOf())
          }
        />
      </CookiesWarning>

      <FloatingComponentsArea>
        <WhatsAppWrap>{whatsAppPopup && <WhatsAppPopup />}</WhatsAppWrap>
        <PageTopButtonContainer>
          {pageTopButton && showPageTopButton && (
            <GPageTopButton
              onClick={handlePageTopButtonClick}
              color={colorTopButton}
            />
          )}
        </PageTopButtonContainer>
      </FloatingComponentsArea>
    </FixedContainer>
  )
}
